import React, {
  createContext, useContext, useState
} from 'react';

import { IdentityContext } from '../../context';
import { useIndex } from '../../hooks';

import { NewFAGuard } from '.';

export const NewFAContext = createContext(null);

export function NewFAProvider() {
  const { person } = useContext(IdentityContext);
  console.log('NEW FA PROVIDER', person);
  const { data: funeralArrangements, loading, update } = useIndex('funeral_arrangements', { person_id: person?.id });
  // check if user has a funeral arrangement
  const [ initLoad, setInitLoad ] = useState(true);

  if (loading) {
    return <div>Loading funeral arrangement...</div>;
  }

  const funeralArrangement = funeralArrangements[0];

  return (
    <NewFAContext.Provider value={{ funeralArrangement, update }}>
      <NewFAGuard initLoad={initLoad} setInitLoad={setInitLoad} />
    </NewFAContext.Provider>
  );
}